import playLogo from '../assets/logos/SpordlePlay.svg';
import playLogoDark from '../assets/logos/SpordlePlayDark.svg';

export const logo = playLogo
export const logoDark = playLogoDark
export const appName = 'Spordle Play'
